import { IndexContainerHeader } from 'modules/intelligentInsights/stoInsights/STO.styles';
import { FlexSpacer } from 'ui/flexSpacer';
import {
  MAIN_HEADER_TIME_RANGE_TITLE,
  HEADER_TITLE,
} from 'modules/intelligentInsights/stoInsights/constants';
import { Select } from 'ui/selectv2/Select';
import { IntelligentInsightsTimeSpanOptions } from 'modules/intelligentInsights/domain.utils';
import { LastUpdatedDate } from 'modules/intelligentInsights/common/LastUpdatedDate';
import { useSTOInsightsCoreContext } from 'modules/intelligentInsights/stoInsights/contexts/CoreContext';

export const STO_MAIN_HEADER_TEST_ID = 'sto-insights-main-header';

export const STOMainHeader = () => {
  const { isLoading } = useSTOInsightsCoreContext();
  const lastRefresh = 'Refresh date here';
  return (
    <>
      <FlexSpacer
        justifyContent="space-between"
        data-test={STO_MAIN_HEADER_TEST_ID}
        gap="double"
        width="100%"
      >
        <FlexSpacer alignItems="flex-start" flexDirection="column" width="100%">
          <IndexContainerHeader>{HEADER_TITLE}</IndexContainerHeader>
          <LastUpdatedDate isLoading={isLoading} lastUpdatedText={lastRefresh} />
        </FlexSpacer>
        <FlexSpacer justifyContent="flex-end" alignItems="center" gap="half" width="100%">
          <div>{MAIN_HEADER_TIME_RANGE_TITLE}</div>
          <Select
            isMulti={false}
            /*// @ts-ignore */
            isSearchable={false}
            options={IntelligentInsightsTimeSpanOptions}
            value={[IntelligentInsightsTimeSpanOptions[0]]}
            onSelect={() => {}}
          />
        </FlexSpacer>
      </FlexSpacer>
    </>
  );
};
